module.exports = __webpack_public_path__ + "img/logo-fr.45559680.svg";